module.exports = __webpack_public_path__ + "media/images/logos/ashby-8b8e62a4758ffa70f5efa24a15929f77.png";